module.exports = __webpack_public_path__ + "img/hiper.3601e733.svg";